<div class="card card-nc" *ngIf="hasEntitlements('BULKTRANSFER_TRANSFER')">
  <div class="card-heading">
    <i class="fa fa-retweet"></i
    ><span class="cardHeaderHeading"> MEU Bulk Transfers </span
    ><span class="pull-right save-card">
      <span [ngClass]="meuTransferActionSuccessFail"
        ><span [ngClass]="meuTransferActionCircle"
          ><i [ngClass]="meuTransferCircleCheck"></i></span
        >&nbsp;&nbsp;{{ meuTransferActionStatus }}</span
      >
      <button
        type="submit"
        [disabled]="transfer_btn"
        (click)="transfer()"
        class="btn btn-nc"
      >
        TRANSFER<i [ngClass]="transfer_btn_spinner"></i></button
    ></span>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-2 meuCardAlign">
        <div id="meu_emblem" [ngClass]="meuClass"></div>
      </div>
      <div class="col-md-3 meuCardAlign">
        <label class="labelCommon" for="meu">Marine Expeditionary Unit:</label
        ><br />
        <div class="form-group">
          <select
            class="form-control input-sm"
            id="meu"
            [(ngModel)]="meu"
            (change)="changemeu()"
          >
            <option *ngFor="let meuOption of meus" [value]="meuOption">{{
              meuOption
            }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4  meuCardAlign">
        <label class="labelCommon" for="mlg">To MLG:</label><br />
        <div class="form-group">
          <select class="form-control input-sm" id="mlg" [(ngModel)]="mlg">
            <option *ngFor="let mlgOption of mlgs" [value]="mlgOption">{{
              mlgOption
            }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-3 meuCardAlign">
        <label class="labelCommon" for="shipName"
          >From Ship Location (optional):</label
        ><br />
        <app-dropdown-select-control
          *ngIf="profiles"
          classes="form-control input-sm "
          placeholder=""
          [source]="profiles"
          (valueSelected)="selectLocation($event)"
        >
        </app-dropdown-select-control>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-6" *ngIf="hasEntitlements('BULKTRANSFER_ACTIVATE')">
    <div class="card card-nc">
      <div class="card-body-nospace">
        <span class="labelCommon"> Click to Activate </span>
        <span class="pull-right save-card">
          <span [ngClass]="meuActActionSuccessFail">
            <span [ngClass]="meuActActionCircle"
              ><i [ngClass]="meuActCircleCheck"></i></span
            >&nbsp;&nbsp;{{ meuActActionStatus }}</span
          >
          <button
            type="submit"
            [disabled]="activate_btn"
            (click)="activate()"
            class="btn btn-nc"
            style="height: 55px; margin: -3px;"
          >
            ACTIVATE
          </button> </span
        ><br />
        <span class="meuLabel">MEU {{ meu }}</span>
      </div>
    </div>
  </div>
  <div class="col-md-6" *ngIf="hasEntitlements('BULKTRANSFER_SUSPEND')">
    <div class="card card-nc">
      <div class="card-body-nospace">
        <span class="labelCommon"> Click to Suspend </span>
        <span class="pull-right save-card">
          <span [ngClass]="meuSuspActionSuccessFail"
            ><span [ngClass]="meuSuspActionCircle"
              ><i [ngClass]="meuSuspCircleCheck"></i></span
            >&nbsp;&nbsp;{{ meuSuspActionStatus }}</span
          >
          <button
            type="submit"
            [disabled]="suspend_btn"
            (click)="suspend()"
            class="btn btn-nc"
            style="height: 55px; margin: -3px;"
          >
            SUSPEND
          </button> </span
        ><br />
        <span class="meuLabel">MEU {{ meu }}</span>
      </div>
    </div>
  </div>
</div>
